<template>
  <div>
    <div id="ConsultaDireccion_div" class="container-fluid">
      <!-- NUEVO LAYOUT -->
      <div id="encabezados-tp">
          <h1>Consulta para Juzgado</h1>
          <h3 style="color: var(--gris-pj)">Busca y consulta toda información referente a las cédulas de notificación</h3>
          <div class="hr-titulo"></div>
      </div>
      <div class="row" style="margin-top: 3em;">
        <!-- SECCION PARA LOS FILTROS DE BUSQUEDA -->
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pb-4">
          <div class="card">
            <div class="card-header">
              <h5><strong>Filtros de búsqueda</strong></h5>
            </div>
            <div class="card-body">
              <FiltrosDeBusqueda
                :mostrar="false"
                :posicionHorizontal="true"
                :conSwitchHabilitacion="true" 
                :catalogos="catalogos" 
                :ejecutaLaFuncion="evtBuscarCedulas" 
                :filtrosEstablecidos="filtrosEstablecidos" 
                :tituloDeBusqueda="''"
                :informacionEnRangoDeFechas="'- (Fecha de registro)'"
                v-on:cambioTipoDeCedula="evtCambioTipoCedula"
                v-on:AccionEnSwitchDeFiltros="evtAccionEnSwitchDeFiltros"
                :ref="REF_FB"></FiltrosDeBusqueda>
            </div>
          </div>
        </div>
        <!-- SECCION LISTADO DE CEDULAS -->
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-3">
          <div class="card">
            <div class="card-header">
              <div class="form-inline justify-content-between flex-wrap">
                <h5><strong>Cédulas encontradas&nbsp;&nbsp;&nbsp;[ {{ this.cedulasBD.length }} ]</strong></h5>
                <div id="s-filtros" class="form-inline justify-content-between flex-wrap" style="gap: 0.5em !important;">
                  <div id="filtros-input-cedulas-memoria">
                    <input v-model="f_busqueda" type="text" id="f-busqueda" placeholder="Buscar en todas las columnas" class="form-control" style="width: 300px;"/>
                  </div>
                  <div>
                    <button type="button" id="btn-limpiar-filtro" @click="evtResetearFiltros" class="btn-sm btn-primary"><i class="fas fa-undo"></i></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body" style="padding: 1.5rem 2rem 1.5rem 2rem !important;">
              <div v-show="!cargandoCedulas">
                <div id="filtros-memoria-cedulas-vcdjz" :class="[(hayCedulasSeleccionadas) ? 'form-inline justify-content-between mb-2' : 'form-inline justify-content-end']">
                  <div v-if="hayCedulasSeleccionadas" class="form-inline justify-content-between">
                    <button id="acciones-regreso-cedula" type="button" @click="accionEnModal({ modal: 'modal-confirmacion-regreso', mostrar: 'show' })" class="btn btn-light"><i class="fas fa-undo-alt"></i>&nbsp;&nbsp;Regresar a área encargada</button>
                  </div>
                  <div class="pt-2" v-if="hayCedulasSeleccionadas">
                    <h6><strong><i class="fas fa-check-square"></i>&nbsp;&nbsp;Cédulas: {{ numeroDeCedulasParaRegreso }}</strong></h6>
                  </div>
                </div>
                <TablaGenericaCedulas class="table-responsive"
                  :idDelInput="idTabla" 
                  :encabezadosColumnas="encabezadosColumnas" 
                  :accionesEnTabla="tablaAcciones" 
                  :listaDeCedulas="cedulasTablaConFiltros"
                  :resaltarFila="resaltarFilaProp"                       
                  v-on:accionFuncionDetalles="evtDetallesCedula"
                  v-on:accionesFuncionDeEditar="evtEditarCedula"
                  v-on:accionesFuncionDeResultado="evtResultadoCedula"
                  v-on:obtenerDocumento="evtDescargarDocumento"
                  :conResponsive="true"
                  v-on:elementosSeleccionados="evtObtenerCedulasSeleccionadas"
                  :ref="REF_T_CEDULAS"
                  :key="'TABLA_CEDULAS' + contRenderTablaCedulas"></TablaGenericaCedulas>
              </div>
              <div v-show="cargandoCedulas" class="contenedor-cargando" style="height: 300px ;">
                  <div class="text-center">
                      <i class="fas fa-spinner fa-spin fa-5x"></i>
                      <h4 class="mt-4">Cargando cédulas</h4>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL CONFIRMACION -->
    <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-confirmacion-regreso">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Mensaje del sistema</h5>
                </div>
                <div class="modal-body pl-4 pr-4">
                    <div class="form-group">
                        <div id="info-modal" class="alert alert-secondary text-jsutify" role="alert">
                          <h4><i class="fas fa-info-circle"></i>&nbsp;&nbsp;Nota</h4>
                          <hr style="height:1px;border:none;color:#FFF;background-color:rgb(65, 65, 65); margin-top:9px; margin-bottom:1em;"/>
                          <h6>Solo se pondran regresar las cédulas seleccionadas que hubiesen sido enviadas previamente a un área encargada y a su vez el área encargada haya enviado las cedulas al juzgado</h6>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="form-inline justify-content-end">
                          <h6 class="mr-3">¿Deseas continuar?</h6>
                          <button type="button" class="btn btn-success mr-2" @click="regresarCedulasBD"><i class="fas fa-check"></i>&nbsp;&nbsp;Si</button>
                          <button type="button" class="btn btn-danger" @click="accionEnModal({ modal: 'modal-confirmacion-regreso', mostrar: 'hide' })"><i class="fas fa-times"></i>&nbsp;&nbsp;No</button>
                        </div>
                    </div>
                </div>             
            </div>
        </div>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import sistemas from '@/../static/js/sistemas'
  import comun from "@/../static/js/comun"
  import api from '@/../static/js/api'
  import axios from 'axios'
  import router from '@/router/index'
  import VueMask from 'v-mask'
  import { mapActions } from 'vuex'

  Vue.use(VueMask);
  export default {
   components: {
      FiltrosDeBusqueda: sistemas.SINOJ.FiltrosDeBusqueda,
      TablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas
    },
    data() {
      return {
        enumeraciones,
        catalogos: [
          { catalogoId: 'filtroNumeroFolio', idDelInput: 'FNumFolioVCDJZ'},
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_PartidoJudicial_ConsultaDireccion' },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Materia_ConsultaDireccion' },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Area_ConsultaDireccion' },
          { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoDocumento_ConsultaDireccion' },
          { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo_ConsultaDireccion' },
          { catalogoId: enumeraciones.sinoj.catalogos.TiposDeCedula, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoCedula_ConsultaDireccion' },
          { catalogoId: enumeraciones.catalogos.FechaDeInicio },
          { catalogoId: enumeraciones.catalogos.FechaFinal },
          { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'filtroDeBusqueda_numeroExtra_ConsultaDireccion' }
        ],
        filtrosEstablecidos: {},
        idTabla: 'tablaCedulasJuzgado',
        encabezadosColumnas: ['Folio', 'Tipo de documento','Consecutivo', 'Tipo de cédula','Persona a notificar', 'Fecha de envío a juzgado','Estatus','Resultado','Fecha de resultado','Fecha de envío a dirección','Fecha de audiencia', '',''],//
        tablaAcciones: { motrarAcciones: true, check: true, resultado: true, eliminar: false, detalles: true, editar: false, editarCedula: true, documento: true },
        tipoCedulaId: -1,
        REF_FB: 'REFFiltrosBVCJZ',
        cargandoCedulas: false,
        REF_T_CEDULAS: 'RefTCedulasJZ',
        mesajeSinCedulas: 'No se ha realizado ninguna búsqueda, en el paso 1 presione el botón de Buscar.',
        f_busqueda : null,
        cedulasBD: [],
        cedulasTabla: [],
        cedulasTablaConFiltros: [],        
        FILTROS_CARGADOS_PREVIAMENTE: null,
        contadorRenderFiltros: 0,
        FILTROS_BUSQUEDA: null,
        cargoAreaDeUsuario: false,
        filtrosDeBusquedaSecciones: {
          expediente: true,
          cedula: true,
          fechas: true
        },
        regreso: {
          cedulas:[]
        },
        contRenderTablaCedulas: 0,
        resaltarFilaProp: {
          aplicarValidacion: true,
          validacion: (index, cedula) => {
            let valor = Object.values(cedula);
            const POSICION_COLUMNA_ESTATUS = 6;
            const ESTATUS_A_RESALTAR = 'Regresada';
            const SE_PUEDE_APLICAR_VALIDACION = (valor != null && valor != undefined && valor.length >= POSICION_COLUMNA_ESTATUS);
            return (SE_PUEDE_APLICAR_VALIDACION && valor[POSICION_COLUMNA_ESTATUS] == ESTATUS_A_RESALTAR);
          }
        }
      }
    },
    methods: { 
      evtDescargarDocumento: function(cedula) {
        if(this.campoRequeridoEsValido(cedula)) {
          const CEDULA_OBJ_DB = this.cedulasBD.find(cDB => cDB.CedulaId == cedula.Folio);
          if(this.campoRequeridoEsValido(CEDULA_OBJ_DB)) {
            this.descargarDocumentoDeCedula({ rutaDelArchivo: CEDULA_OBJ_DB.ArchivoRuta });
            return;
          }
        }
        comun.mensajeDeAlerta('Ocurrio un error al cargar el documento, vuelve a intentar');
      },
      descargarDocumentoDeCedula: function({ rutaDelArchivo }) { 
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${ rutaDelArchivo }`
          a.click();
      },
      accionEnModal: function({ modal, mostrar }) {
        $("#" + modal).modal(mostrar);
      },
      regresarCedulasBD: async function() { 
        this.accionEnModal({ modal: 'modal-confirmacion-regreso', mostrar: 'hide' })
        try {
            const SERVIDOR = api.conexion;
            const METODO_API_MODIFICAR = api.SINOJ.sistema.consultas.consultaJuzgado.RegresarCedulaADireccion;
            let urlApi = SERVIDOR + METODO_API_MODIFICAR;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            const PETICION = { Cedulas: this.regreso.cedulas, ConResultado: false };
            comun.SeEstaCargandoInformacion(true);
            const RESPUESTA_SOLICITUD = await axios.post(urlApi, PETICION, headerPeticion);
            const DATOS = await RESPUESTA_SOLICITUD.data;
            let { SiHayError, Error, Satisfactorio } = DATOS;
            if (SiHayError) {
                let mensajeError = Error.Mensaje;
                console.log(Error);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(mensajeError);
            } 
            else { 
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(Satisfactorio);
                this.obtenerCedulasBD();
            }
        }
        catch(excepcion) {
            comun.SeEstaCargandoInformacion(false);
            console.log(excepcion);
            comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
        }
      },
      evtObtenerCedulasSeleccionadas: function(cedulas) {
        const CEDULAS_SELECCIONADAS = cedulas.filter(c => c.enviar);
        if(this.campoRequeridoEsValido(CEDULAS_SELECCIONADAS)) {
          const CEDULAS_CON_DATOS = this.cedulasBD.filter(cBD => CEDULAS_SELECCIONADAS.some(cs => cs.folio == cBD.CedulaId));
          this.filtraCedulasParaRegreso({ cedulas: CEDULAS_CON_DATOS });
        }
        else
          this.regreso.cedulas = [];
      }, 
      filtraCedulasParaRegreso: function({ cedulas }) {
        if(this.campoRequeridoEsValido(cedulas))
          this.regreso.cedulas = cedulas.filter(c => this.campoRequeridoEsValido(c.FechaDeEnvio) && this.campoRequeridoEsValido(c.FechaDeEnvioAJuzgado));
        else
          this.regreso.cedulas = [];
      } ,   
      evtAccionEnSwitchDeFiltros: function(accionRealizada) {
        switch(accionRealizada.tipoDeFiltro) {
            case 'Expediente':
                this.filtrosDeBusquedaSecciones.expediente = accionRealizada.habilitar;
                break;
            case 'Cedula':
                this.filtrosDeBusquedaSecciones.cedula = accionRealizada.habilitar;
                break;
            case 'Fechas':
                this.filtrosDeBusquedaSecciones.fechas = accionRealizada.habilitar;
                break;
            default:
                break;
        };
      },
      filtrarCedulasTabla: function(e) {
        // filtra por columnas
        this.cedulasTablaConFiltros = this.cedulasTabla
        .filter(c => { 
          return Object.values(c).some(valorColumna => this.predicateFiltradoPorSimilitud(valorColumna, this.f_busqueda));
        })
      },
      predicateFiltradoPorSimilitud: function(elementoAEvaluar,compararCon) { 
        if(this.campoRequeridoEsValido(compararCon)) {
          if(this.campoRequeridoEsValido(elementoAEvaluar) && elementoAEvaluar.toString().toUpperCase().startsWith(compararCon.toString().toUpperCase()))
            return true;
          else
            return false;
        }
        else
            return true;
      },
      limpiarFiltrosDeTabla: function() {
        this.f_busqueda = null;
      },
      evtResetearFiltros: function() {
        this.limpiarFiltrosDeTabla();
        this.cedulasTablaConFiltros = this.cedulasTabla;
      },
      obtenerCedulasBD: function() { 
        const SERVIDOR = api.conexion;
        const METODO_API_OBTENER = api.SINOJ.sistema.consultas.consultaJuzgado.ObtenerCedulasConsultaDeJuzgado;
        let urlApi = SERVIDOR + METODO_API_OBTENER;
        let peticionArchivos = false;
        /*let peticionAPI = {
            Folio: (this.campoRequeridoEsValido(this.$refs[this.REF_FB].numeroDeFolio) && this.filtrosDeBusquedaSecciones.cedula) ? this.$refs[this.REF_FB].numeroDeFolio : null,
            PartidoJudicialId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_PartidoJudicial.partidoJudicialId) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.REF_FB].parametros_PartidoJudicial.partidoJudicialId : null,
            MateriaId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_Materia.materiaId) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.REF_FB].parametros_Materia.materiaId : null,
            JuzgadoId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_Area.areaId) ? this.$refs[this.REF_FB].parametros_Area.areaId : null,
            TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId : null,
            NumeroDeDocumento: this.campoRequeridoEsValido(this.$refs[this.REF_FB].consecutivo) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.REF_FB].consecutivo : null,
            TipoDeCedulaId: this.campoRequeridoEsValido(this.tipoCedulaId) && this.filtrosDeBusquedaSecciones.cedula ? this.tipoCedulaId : null,
            FechaInicial: this.campoRequeridoEsValido(this.$refs[this.REF_FB].fechaInicial) && this.filtrosDeBusquedaSecciones.fechas ? this.$refs[this.REF_FB].fechaInicial : null,
            FechaFinal: this.campoRequeridoEsValido(this.$refs[this.REF_FB].fechaFinal) && this.filtrosDeBusquedaSecciones.fechas ? this.$refs[this.REF_FB].fechaFinal : null,
            esPrueba: false
        }*/

        let peticionAPI = {
            Folio: null,
            PartidoJudicialId: null,
            MateriaId: null,
            JuzgadoId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_Area.areaId) ? this.$refs[this.REF_FB].parametros_Area.areaId : null,
            TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId : null,
            NumeroDeDocumento: this.campoRequeridoEsValido(this.$refs[this.REF_FB].consecutivo) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.REF_FB].consecutivo : null,
            TipoDeCedulaId: null,
            FechaInicial: this.campoRequeridoEsValido(this.$refs[this.REF_FB].fechaInicial) && this.filtrosDeBusquedaSecciones.fechas ? this.$refs[this.REF_FB].fechaInicial : null,
            FechaFinal: this.campoRequeridoEsValido(this.$refs[this.REF_FB].fechaFinal) && this.filtrosDeBusquedaSecciones.fechas ? this.$refs[this.REF_FB].fechaFinal : null,
            esPrueba: false
        }

        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
        this.cargandoCedulas = true;
        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticionAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        let mensajeError = respuesta.data.Error.Mensaje;
                        console.log(respuesta.data.Error);
                        comun.mensajeDeAlerta(mensajeError, null, null);
                    } 
                    else { 
                      //console.log('data::',respuesta.data.Cedulas)
                        this.cedulasBD = (respuesta.data.Cedulas != null) ? respuesta.data.Cedulas : [];
                        this.cedulasTabla = this.darFormatoCedulasTabla(this.cedulasBD);                        

                        $("#filtros-input-cedulas-memoria input").on("change paste keyup", (e) => {
                            if(this.cedulasTabla.length > 0 && !this.cargandoCedulas) {
                                this.filtrarCedulasTabla(e);
                                this.regreso.cedulas = [];
                            }
                        }); 
                        this.cedulasTablaConFiltros = this.cedulasTabla;                        
                    }
                    // se limpian variables para el regreo de las cedulas
                    this.contRenderTablaCedulas ++;
                    this.regreso.cedulas = [];

                    this.cargandoCedulas = false;
                    this.obtenerFiltrosDeBusquedaCargados();
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    this.cargandoCedulas = false;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                }
        ); 
      },
      darFormatoCedulasTabla: function(cedulas) {
          let cedulasConFormato = [];
          cedulas.forEach(c => {
            let cedulaFormatoTabla = this.cedulaAObjetoTabla(c);
            cedulasConFormato.push(cedulaFormatoTabla);
          });
          return cedulasConFormato;
      },
      cedulaAObjetoTabla: function(cedula) {      
          moment.locale('es');  
          let cedulaObjTabla = {};
          cedulaObjTabla.Folio = cedula.CedulaId;
          //cedulaObjTabla.Juzgado = (cedula.Expediente.Juzgado != null ) ? cedula.Expediente.Juzgado.Nombre : 'Sin juzgado';
          cedulaObjTabla.TipoDocumento = cedula.Expediente != null ? cedula.Expediente.TipoDocumento.Nombre : 'Sin documento';
          cedulaObjTabla.Consecutivo = cedula.Expediente != null ? cedula.Expediente.NumeroDeDocumento : 'Sin consecutivo';
          cedulaObjTabla.TipoCedula = this.campoRequeridoEsValido(cedula.TipoCedula) ? cedula.TipoCedula.Nombre.trim() : 'Sin tipo de cedula';    
          console.log('cedula::id::' + cedula.CedulaId + ', personas::',cedula.PersonasANotificar);
          cedulaObjTabla.PersonaANotificar = "Sin persona a notificar";
          if(this.campoRequeridoEsValido(cedula.PersonasANotificar) && this.campoRequeridoEsValido(cedula.PersonasANotificar[0].DatosGenerales)) {
                const { Fisica, Moral } = cedula.PersonasANotificar[0].DatosGenerales;
                if(this.campoRequeridoEsValido(Fisica))
                    cedulaObjTabla.PersonaANotificar = `${ Fisica.Nombre.toUpperCase().trim() } ${ (this.campoRequeridoEsValido(Fisica.ApellidoPaterno)) ? Fisica.ApellidoPaterno.toUpperCase().trim() : "" }${ (this.campoRequeridoEsValido(Fisica.ApellidoMaterno)) ? (" " + Fisica.ApellidoMaterno.toUpperCase().trim()) : "" }`; 
                else if(this.campoRequeridoEsValido(Moral))
                    cedulaObjTabla.PersonaANotificar = `${ Moral.Nombre.trim() }`; 
          }       
          cedulaObjTabla.FechaDeEnvioAJuzgado = cedula.FechaDeEnvioAJuzgado != null ? moment(cedula.FechaDeEnvioAJuzgado).format("DD MMMM YYYY") : null;
          cedulaObjTabla.Estatus = cedula.Estatus.Nombre; 
          cedulaObjTabla.Resultado = 'Sin resultado';
          cedulaObjTabla.FechaResultado = 'Sin fecha de resultado';
          if(this.campoRequeridoEsValido(cedula.Resultado)) {
            const { Nombre } = cedula.Resultado.TipoResultado;
            cedulaObjTabla.Resultado = Nombre;
            cedulaObjTabla.FechaResultado = moment(cedula.Resultado.FechaResultado).format("DD MMMM YYYY");
          }
          cedulaObjTabla.FechaDeEnvio = (this.campoRequeridoEsValido(cedula.FechaDeEnvio)) ? moment(cedula.FechaDeEnvio).format("DD MMMM YYYY") : 'Sin fecha';
          let acuerdo = cedula.Acuerdos.find((acuerdo) => acuerdo.EsPrincipal);
          cedulaObjTabla.FechaAudiencia = (this.campoRequeridoEsValido(acuerdo.FechaDeAudiencia)) ? moment(acuerdo.FechaDeAudiencia).format("DD MMMM YYYY") : 'Sin fecha';
          cedulaObjTabla.ResultadoParcialComplementado = cedula.ResultadoParcialComplementado; 
          cedulaObjTabla.Jurisdiccion = cedula.Jurisdiccion;
          
          //cedulaObjTabla.Resultado = (cedula.Resultado != null) ? cedula.Resultado.TipoResultado.Nombre : 'Sin resultado';
          return cedulaObjTabla;
      },
      obtenerFiltrosDeBusquedaCargados: function() {
        this.FILTROS_BUSQUEDA = {
            PartidoJudicialId: this.$refs[this.REF_FB].parametros_PartidoJudicial.partidoJudicialId,
            MateriaId: this.$refs[this.REF_FB].parametros_Materia.materiaId,
            JuzgadoId: this.$refs[this.REF_FB].parametros_Area.areaId,
            TipoDeDocumentoId: this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId,
            NumeroDeDocumento: this.$refs[this.REF_FB].consecutivo,
            TipoDeCedulaId: this.tipoCedulaId,
            FechaInicial: this.$refs[this.REF_FB].fechaInicial,
            FechaFinal: this.$refs[this.REF_FB].fechaFinal,
            FiltrosHabilitados: this.filtrosDeBusquedaSecciones
        }
      },
      evtDetallesCedula: function(evento) {
        let cedulaSeleccionada = this.obtenerCedulaSeleccionado(evento);
        router.push({ name: "DetallesConsultaJuzgado", params: { folio: cedulaSeleccionada.CedulaId, cedula: cedulaSeleccionada, filtrosPrevios: this.FILTROS_BUSQUEDA } });
      },
      evtEditarCedula: function(evento){
        let cedulaSeleccionada = this.obtenerCedulaSeleccionado(evento);
        router.push({ name: "CreacionDeCedula", params: { cedulaEditarId: cedulaSeleccionada.CedulaId} });
      },
      evtResultadoCedula: function(evento){
        let cedulaSeleccionada = this.obtenerCedulaSeleccionado(evento);
        router.push({ name: "ResultadoCitatorio", params: { folio: cedulaSeleccionada.CedulaId, cedula: cedulaSeleccionada, filtrosPrevios: this.FILTROS_BUSQUEDA } });
      },
      obtenerCedulaSeleccionado: function(evento) {
        let cedula = null;
        const CEDULA_SELECCIONADA = evento.target.getAttribute('id');
        const ID_CEDULA = parseInt(this.obtenerCedula(CEDULA_SELECCIONADA));
        this.cedulasBD.filter(cDB => cDB.CedulaId == ID_CEDULA).forEach(c => {
            cedula = c;
        });
        return cedula;
      },
      obtenerCedula: function(cedulaSeleccionada) {
        const CEDULA = cedulaSeleccionada.split('-');
        const POSICION_ID = (CEDULA.length - 1);
        const ID_CEDULA = CEDULA[POSICION_ID];
        return ID_CEDULA;
      },
      evtCambioTipoCedula: function(evento) {
        const TIPO_CEDULA_ID = parseInt(evento.target.value);
        this.tipoCedulaId = (TIPO_CEDULA_ID > 0) ? TIPO_CEDULA_ID : -1;
      },
      evtBuscarCedulas: function() {
        if(this.validaBusqueda())
        {
          comun.mensajeDeAlerta("Ingrese un Tipo de Documento.", null, null);
        }
        else
          this.obtenerCedulasBD();
      },
      validaBusqueda: function(){
        if(!this.$refs[this.REF_FB].filtrosFechas.habilitados && (this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId == -1 || this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId == undefined))
          return true;
        else
          return false;
      },
      cargaCedulas: function () {
        //console.log("Se obtienen cédulas");
      },
      detallesCedulaAsignada: function (evento) {
        let id = evento.target.getAttribute('id');
        let folioCedula = id.split('-')[id.split('-').length - 1];
        router.push({ name: "DetallesConsultaJuzgado", params: { FolioCedula: folioCedula } })
      },
      campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'array' || campo instanceof Array) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo.length > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      asignarValoresDeUsuario: async function(areaDeUsuario) { 
          // se asignan los valores del usuario (en mounted y no en created porque es hasta que este creada la instancia del componente FiltrosDeBusqueda)
          if(this.campoRequeridoEsValido(areaDeUsuario)) {
              const { AreaId } = areaDeUsuario;
              this.$refs[this.REF_FB].parametros_Area.esInformativo = this.campoRequeridoEsValido(AreaId) ? true : false;
              this.$refs[this.REF_FB].parametros_Area.areaId = this.campoRequeridoEsValido() ? AreaId : -1;
              this.$refs[this.REF_FB].parametros_Area.key = 'CFJZVCD' + this.contadorRenderFiltros;
              const VALOR_EVENTO = {
                  target: { value: this.campoRequeridoEsValido(AreaId) ? AreaId : -1 }
              };
              this.$refs[this.REF_FB].cambioDeArea(VALOR_EVENTO);
              const AREA_COMPLETA = await Promise.resolve(this.obtenerMateriaYArea({ areaId: AreaId }));

              //Actualizo partido
              this.$refs[this.REF_FB].parametros_PartidoJudicial.parametros.AreaId = (this.campoRequeridoEsValido(AreaId)) ? parseInt(AreaId) : -1;
              this.$refs[this.REF_FB].parametros_PartidoJudicial.partidoJudicialId = (this.campoRequeridoEsValido(AREA_COMPLETA) && this.campoRequeridoEsValido(AREA_COMPLETA.PartidoJudicial)) ? AREA_COMPLETA.PartidoJudicial.PartidoJudicialId : -1;

              //Actualizo materia
              this.$refs[this.REF_FB].parametros_Materia.parametros.AreaId = (this.campoRequeridoEsValido(AreaId)) ? parseInt(AreaId) : -1;
              this.$refs[this.REF_FB].parametros_Materia.materiaId = (this.campoRequeridoEsValido(AREA_COMPLETA) && this.campoRequeridoEsValido(AREA_COMPLETA.Materias)) ? AREA_COMPLETA.Materias[0].MateriaId : -1;

              this.$refs[this.REF_FB].conRenderGeneral += 3;
              this.$refs[this.REF_FB].evtDeshabilitarFiltros('Cedula');
          }
      },
      obtenerMateriaYArea: async function({ areaId }) {
          let area = null;
          try {
              const SERVIDOR = api.conexion;
              const METODO_API_OBTENER = api.PJ.catalogos.C001Areas;
              const URL_SEVICIO = SERVIDOR + METODO_API_OBTENER;
              const PETICION_API = { AreaId: areaId, conPartidoJudicial: true, conMaterias: true }; 
              let peticionArchivos = false;
              let HEADERS = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
              const RESPUESTA = await axios.post(URL_SEVICIO, PETICION_API, HEADERS);
              const DATOS = await RESPUESTA.data;
              let { SiHayError, Error, Areas } = DATOS;
              if (SiHayError) {
                  console.log(Error);
              } 
              else {
                if(this.campoRequeridoEsValido(Areas))
                  area = Areas[0];
              }
          }
          catch(excepcion) {
              console.log(excepcion);
          }
          return area;
      }
    },
    async mounted() {
      if(this.FILTROS_CARGADOS_PREVIAMENTE != null && this.FILTROS_CARGADOS_PREVIAMENTE != undefined) {
        // renderizar catalogos de componente hijo filtrosDeBusqueda con valor elegido previamente
        if(this.FILTROS_CARGADOS_PREVIAMENTE.cargarConFiltros) {
          // se asignan los valores de los filtros 
            this.$refs[this.REF_FB].parametros_PartidoJudicial.partidoJudicialId = this.FILTROS_CARGADOS_PREVIAMENTE.PartidoJudicialId;
            this.$refs[this.REF_FB].parametros_Materia.materiaId = this.FILTROS_CARGADOS_PREVIAMENTE.MateriaId;
            /* this.$refs[this.REF_FB].parametros_Area.areaId = this.FILTROS_CARGADOS_PREVIAMENTE.JuzgadoId; */
            this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId = this.FILTROS_CARGADOS_PREVIAMENTE.TipoDeDocumentoId;
            this.$refs[this.REF_FB].consecutivo = this.FILTROS_CARGADOS_PREVIAMENTE.NumeroDeDocumento;
            this.$refs[this.REF_FB].fechaInicial = this.FILTROS_CARGADOS_PREVIAMENTE.FechaInicial;
            this.$refs[this.REF_FB].fechaFinal = this.FILTROS_CARGADOS_PREVIAMENTE.FechaFinal;

            // se actualizan los catalogos
            this.$refs[this.REF_FB].parametros_PartidoJudicial.key = 'CFPRJVCD' + this.contadorRenderFiltros;
            this.$refs[this.REF_FB].parametros_Materia.key = 'CFMTVCD' + this.contadorRenderFiltros;
           /*  this.$refs[this.REF_FB].parametros_Area.key = 'CFJZVCD' + this.contadorRenderFiltros; */
            this.$refs[this.REF_FB].parametros_TipoDocumento.key = 'CFTDVCD' + this.contadorRenderFiltros;
            this.$refs[this.REF_FB].parametros_TiposCedula.valorDefinido = this.tipoCedulaId;
            this.$refs[this.REF_FB].parametros_TiposCedula.key = 'CFTCVCD' + this.contadorRenderFiltros;
            this.contadorRenderFiltros += 1;

            //carga los valores de los switch para la deshabilitacion de filtros
            if(this.FILTROS_CARGADOS_PREVIAMENTE.FiltrosHabilitados != null) {
              const { expediente, cedula, fechas } = this.FILTROS_CARGADOS_PREVIAMENTE.FiltrosHabilitados;
              // switch filtros expediente
              if(expediente)
                this.$refs[this.REF_FB].evtHabilitarFiltros('Expediente');
              else
                this.$refs[this.REF_FB].evtDeshabilitarFiltros('Expediente');
              // switch filtros cedula
              if(cedula)
                this.$refs[this.REF_FB].evtHabilitarFiltros('Cedula');
              else
                this.$refs[this.REF_FB].evtDeshabilitarFiltros('Cedula');
              // switch filtros fechas
              if(fechas)
                this.$refs[this.REF_FB].evtHabilitarFiltros('Fechas');
              else
                this.$refs[this.REF_FB].evtDeshabilitarFiltros('Fechas');
            }
        }        
      }
      if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area)) {
          this.cargoAreaDeUsuario = true;
          await Promise.resolve(this.asignarValoresDeUsuario(this.$store.state.Login_Usuario.Area));
          this.obtenerCedulasBD();
      }
    },
    created() {
      //console.log('props::',router.history.current.params);
      this.FILTROS_CARGADOS_PREVIAMENTE = router.history.current.params.filtrosParaCargar;
      if(this.FILTROS_CARGADOS_PREVIAMENTE != null && this.FILTROS_CARGADOS_PREVIAMENTE != undefined) {
        if(this.FILTROS_CARGADOS_PREVIAMENTE.cargarConFiltros) {
          this.tipoCedulaId = this.FILTROS_CARGADOS_PREVIAMENTE.TipoDeCedulaId;
        }
      }      
    },
    computed: {
      hayCedulasSeleccionadas() {
        return (this.regreso.cedulas.length > 0);
      },
      numeroDeCedulasParaRegreso() {
        return (this.regreso.cedulas.length);
      }
    },
    watch: {
        '$store.state.Login_Usuario.Area': async function() {
            if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area) && !this.cargoAreaDeUsuario) {
                this.cargoAreaDeUsuario = true;
                await Promise.resolve(this.asignarValoresDeUsuario(this.$store.state.Login_Usuario.Area));
                this.obtenerCedulasBD();
            }
        }
    }
  }
</script>
<style scoped>

#s-filtros .btn-sm {
  cursor: pointer;
  background-color: rgb(27, 25, 25);
  padding: 5px 15px 5px 15px;
}

#s-filtros input {
  background-color: rgb(224, 224, 224) !important;
  color: #1b1919 !important;
}

#s-filtros .form-control::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #858585 !important;
  opacity: 1; /* Firefox */
}

#s-filtros .form-control:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #858585 !important;
}

#s-filtros .form-control::-ms-input-placeholder { /* Microsoft Edge */
  color: #858585 !important;
}

#encabezados-tp {
    margin-bottom: 1em;
}

#encabezados-tp h1 {
    margin-bottom: 0;
    font-weight: bold;
}

#encabezados-tp h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:var(--verde-pj-100)
}

#ConsultaDireccion_div .card-header {
    background-color: rgb(70, 70, 70);
}

#ConsultaDireccion_div .card-body {
    background-color: rgb(49, 49, 49);
}

#ConsultaDireccion_div .card {
    border: 1px solid rgb(129, 129, 129) !important;
}

#info-modal h4 {
  font-size: 1.5em;
}

#info-modal h6 {
  font-size: 1em;
}

#modal-confirmacion-regreso .modal-lg {
    max-width: 50% !important;
}

#modal-confirmacion-regreso .modal-header {
    background-color: rgb(36, 34, 34);
    border: none;
}

#modal-confirmacion-regreso .modal-dialog {
    position: relative;
    top: 40%;
    transform: translateY(-50%);
}

#modal-confirmacion-regreso .modal-footer {
    border-top-width: 0.1em;
    border-top-color: rgb(29, 29, 29);
    padding-top: 0.8em;
    padding-bottom: 0.8em;
}

.hr-vertical {
  border-left: 2px solid rgb(17, 16, 16);
  height: 2.6em;
  margin-left: 0.5em;
  margin-right: 0.5em;
}

#acciones-seleccionadas {
  background-color: #2c2d31;
  color: white;
  border-color: #2c2d31;
  font-size: 1.1em;
}

#acciones-regreso-cedula  {
  color: #fff;
  background-color: #c01c2c;
  border-color: #c01c2c;
}


#acciones-regreso-cedula:hover, #acciones-regreso-cedula:focus{
  /* color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa; */

  color: #fff;
  background-color: #c01c2c;
  border-color: #c01c2c;
}

.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}

@media screen and (max-width: 1203px) {
  #filtros-memoria-cedulas-vcdjz {
    flex-direction: column !important;
  }

  #filtros-input-cedulas-memoria {
    flex-direction: column !important;
    margin-bottom: 10px !important;
    margin-right: 0px !important;
  }

  #filtros-nivel-urgencia {
    flex-direction: column !important;
    margin-bottom: 10px !important;
    margin-right: 0px !important;
  }

  #filtros-nivel-urgencia select{
    width: 100% !important;
  }

  #filtros-input-cedulas-memoria input {
    width: 100% !important;
  }

  .f-item {
    width: 100% !important;
  }

  #filtros-memoria-cedulas-vcdjz .btn-sm {
    width: 100% !important;
  } 
}

#filtros-memoria-cedulas-vcdjz .btn-sm {
  cursor: pointer;
  background-color: rgb(27, 25, 25);
  padding: 5px 15px 5px 15px;
} 

#filtros-memoria-cedulas-vcjz .btn-sm:hover, #filtros-memoria-cedulas-vcjz .btn-sm:focus {
  background-color: black;
}

#filtros-memoria-cedulas-vcdjz .form-control::-webkit-input-placeholder { color: rgb(201, 192, 192); }  /* WebKit, Blink, Edge */
#filtros-memoria-cedulas-vcdjz .form-control:-moz-placeholder { color:  rgb(201, 192, 192); }  /* Mozilla Firefox 4 to 18 */
#filtros-memoria-cedulas-vcdjz .form-control::-moz-placeholder { color:  rgb(201, 192, 192); }  /* Mozilla Firefox 19+ */
#filtros-memoria-cedulas-vcdjz .form-control:-ms-input-placeholder { color:  rgb(201, 192, 192); }  /* Internet Explorer 10-11 */
#filtros-memoria-cedulas-vcdjz .form-control::-ms-input-placeholder { color:  rgb(201, 192, 192); }  /* Microsoft Edge */

.contenedor-sin-cedula {
    /* background-color: rgb(36, 34, 34); */
    height: 40px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.contenedor-cargando {
    /* background-color: rgb(36, 34, 34); */
    height: 40px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

#encabezado-contenedor-contenido {
  background-color: rgb(44, 43, 43);
  padding: 10px;
}


#ConsultaDireccion_div .card-header,
#ConsultaDireccion_div .modal-header {
    background-color: var(--verde-pj);
}

#ConsultaDireccion_div .card-body,
#ConsultaDireccion_div .modal-body {
    background-color: var(--gris-pj-100);
}

#ConsultaDireccion_div .btn-primary {
    background-color: var(--verde-pj-100);
}
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Consultas/ConsultaJuzgado/ConsultaJuzgado.vue